module.exports = __webpack_public_path__ + "img/cash-back.d213954c.svg";